// ============================================================================
//  accordion.js — smooth height open/close for the patent <details> panels
//
//  Native <details> snaps open and shut. This intercepts the toggle and
//  animates the body's height (Web Animations API) so it expands/collapses
//  cleanly, pushing the panels below. Progressive enhancement: without JS (or
//  under reduced motion) the native instant toggle still works.
// ============================================================================

const DURATION = 380; // ms
const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

export function initAccordion({ reducedMotion = false } = {}) {
  const items = document.querySelectorAll('.patent');
  if (!items.length || reducedMotion) return; // native <details> handles it

  items.forEach((details) => {
    const summary = details.querySelector('.patent__summary');
    const body = details.querySelector('.patent__body');
    if (!summary || !body) return;

    let animating = false;

    summary.addEventListener('click', (e) => {
      e.preventDefault(); // take over the native toggle
      if (animating) return;
      if (details.open) collapse();
      else expand();
    });

    function expand() {
      animating = true;
      details.open = true; // reveal so we can measure the full height
      const target = body.scrollHeight;
      const anim = body.animate(
        [{ height: '0px' }, { height: `${target}px` }],
        { duration: DURATION, easing: EASING }
      );
      anim.onfinish = () => {
        body.style.height = ''; // back to natural (auto) height
        animating = false;
      };
    }

    function collapse() {
      animating = true;
      // Rotate the marker back to a plus now, in sync with the closing height
      // (the panel keeps [open] until the animation ends).
      details.classList.add('is-collapsing');
      const start = body.scrollHeight;
      const anim = body.animate(
        [{ height: `${start}px` }, { height: '0px' }],
        { duration: DURATION, easing: EASING }
      );
      anim.onfinish = () => {
        details.open = false; // hide (no flash of full height)
        details.classList.remove('is-collapsing');
        body.style.height = '';
        animating = false;
      };
    }
  });
}
